/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_PROFILE_REQUEST, LOAD_PROFILE_SUCCESS, UPDATE_PROFILE, LOAD_PROFILE_FAILLURE } from '../actions/profileActions';


const initialState = {
  profile: {},
  status: null,
  error: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PROFILE_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.profile = null;
        draft.error = null;
        draft.status = null;
      });
    }

    case LOAD_PROFILE_SUCCESS: {
      const { profile, status } = action.payload;
      return produce(state, (draft) => {
        draft.profile = profile;
        draft.error = null;
        draft.status = status
      });
    }

    case LOAD_PROFILE_FAILLURE: {
      const error = action.payload;
      return produce(state, (draft) => {
        // draft.sections = null;
        draft.error = error;
      });
    }

    case UPDATE_PROFILE: {
      const { profile } = action.payload;

      return produce(state, (draft) => {
        draft.profile = profile;
      });
    }

    default: {
      return state;
    }
  }
};

export default profileReducer;
